export default __webpack_public_path__ + "static/media/pich-close.eaf53961.jpg";